<template>
  <div class="page border-box">
    <div class="pay-box border-box box" style="margin-top: 0;">
      <img class="flex video-img" :src="bag.logo" alt="">
      <div class="flex">
        <p class="video-tit hide">{{bag.name}}</p>
        <p class="video-num" v-if="bagtype==5 || siteBrotherList.length>0">包含{{bag.vnum}}个{{(bag.ptype==1||model==1)?'讲解':'场馆'}}</p>
        <p class="video-num" v-else-if="bagtype!=1">包含{{bag.vnum}}个景点解说</p>
        <p class="video-num" v-else>包含一个景区视频讲解</p>
        <p class="video-price" v-if="appType!=3">￥{{bag.price}}
          <span class="fr" :class="siteBrotherShow?'curr':''" v-if="siteBrotherList.length>0"
                @click="siteBrotherShow=!siteBrotherShow">{{siteBrotherShow?'收起':'展开'}}</span>
        </p>
      </div>
    </div>
    <div class="group-ul" v-if="siteBrotherShow&&model===0">
      <div class="box border-box group-li" v-for="(item,index) in siteBrotherList" :key="index" @click="goViewDetail(item.id,(item.bid||''),'',item.bagtype)">
        <img v-lazy="bag.ptype==1?item.headimg:item.logo" alt="" :data-id="item.id">
        <p class="flex hide">{{bag.ptype==1?item.bagName:item.name}}  <font v-if="item.bagtype==2">(全景VR)</font></p>
      </div>
    </div>
    <div class="group-ul" :class="((payWay==0 || payWay==1) && !memberWay && isBuyOne==1)?'group-ul1':''" v-if="siteBrotherShow&&model==1">
      <div class="box border-box group-li" :class="(idsArr.indexOf(item.bid)>-1)?'curr':''" v-for="(item,index) in siteBrotherList" :key="index"
           @click="goViewDetail(item.id,(item.bid||''),index)" v-if="pid==item.bid">
        <img v-lazy="item.headimg" alt="" :data-id="item.id" :data-ind="index" @click="goViewDetail(item.id,(item.bid||''),'',item.bagtype)">
        <p class="flex hide">
          {{item.bagName}}  <font v-if="item.bagtype==2">(全景VR)</font> <br/>
          <font style="font-size: .24rem; margin-top: .06rem;color:#ff5455;">{{'￥'+item.price}}</font>
        </p>
      </div>
      <div class="box border-box group-li" :class="(idsArr.indexOf(item.bid)>-1)?'curr':''" v-for="(item,index) in siteBrotherList" :key="index"
           @click="goViewDetail(item.id,(item.bid||''),index)" v-if="pid!=item.bid">
        <img v-lazy="item.headimg" alt="" :data-id="item.id" @click="goViewDetail(item.id,(item.bid||''),'',item.bagtype)">
        <p class="flex hide">
          {{item.bagName}} <font v-if="item.bagtype==2">(全景VR)</font> <br/>
          <font style="font-size: .24rem; margin-top: .06rem;color:#ff5455;">{{'￥'+item.price}}</font>
        </p>
      </div>
    </div>

    <template  v-if="memberList && memberList.length > 0">
      <div class="pay-box vip-li" :class="memberInd==index&&memberWay==1?'curr':''" @click="memberInd=index,memberWay=1,(payWay==3?payWay=0:'')" v-for="(item,index) in memberList" :key="index">
        <span class="price-rt"><b>￥{{item.price}}</b> ￥{{item.sellprice}}</span>
        <p class="vip-top border-box">{{item.title}}
          <img src="../../assets/pay-vip-icon.png" alt="" v-if="index==1||index==2">
          <img src="../../assets/pay-vip-icon.png" alt="" v-if="index==1||index==2">
          <img src="../../assets/pay-vip-icon.png" alt="" v-if="index==2">
        </p>
        <p class="vip-bot">{{item.content}}</p>
      </div>
    </template>

    <div v-if="appType!=3">
      <template v-if="model==1">
        <div class="pay-box vip-li" :class="((payWay==0 || payWay==1) && !memberWay && isBuyOne==1)?'curr':''" @click="isBuyOneClick()"
             v-if="siteBrotherList.length>=2">
          <span class="price-rt" style="font-size:.24rem;font-family:normal;line-height:.44rem;">享立减优惠</span>
          <p class="vip-top border-box">购买多张专辑</p>
        </div>

        <div class="pay-box vip-li" :class="((payWay==0 || payWay==1) && !memberWay && isBuyOne==2)?'curr':''"
             @click="isshow==1?(payWay=1,memberWay=0,isBuyOne=2):(payWay=0,memberWay=0,isBuyOne=2)">
          <span class="price-rt">￥{{bag.price}}</span>
          <p class="vip-top border-box">购买当前专辑</p>
          <p class="vip-bot cont" @click="goCoupon" v-if="coupon">优惠券
            <span class="fr">-￥{{coupon.money}} <img src="../../assets/pay-icon-right.png" alt=""></span>
          </p>
        </div>
      </template>
      <template v-else>
        <div class="pay-box vip-li" :class="((payWay==0 || payWay==1) && !memberWay)?'curr':''" @click="isshow==1?(payWay=1,memberWay=0):(payWay=0,memberWay=0)">
          <span class="price-rt">￥{{bag.price}}</span>
          <p class="vip-top border-box">{{(siteBrotherList.length>0)?'购买当前语音包':'购买当前专辑'}}</p>
          <p class="vip-bot cont" @click="goCoupon" v-if="coupon">优惠券
            <span class="fr">-￥{{coupon.money}} <img src="../../assets/pay-icon-right.png" alt=""></span>
          </p>
        </div>
      </template>
    </div>




    <div class="pay-box vip-li" :class="payWay==3 && !memberWay?'curr':''" v-if="OTAShow == 1" @click="payWay=3,memberWay=0">
      <p class="vip-top">激活码<span>（说明：激活码使用后失效）</span></p>
      <p class="vip-bot code">
        <input type="text" placeholder="在此输入激活码" v-model='OTAcode' @focus="payWay=3" />
      </p>
    </div>

    <div class="pay-bottom1"  v-if="memberList && memberList.length > 0 && payWay!=3">
      <div class="pay-bottom-li border-box" :class="!isshow==1?'noOtherPay':''" @click="payWay=0">
        <span class="fl">
          <img src="../../assets/pay-wechat.png" alt="">
          微信支付
        </span>
        <span class="pay-icon">
          <img :src="payWay==0?require('../../assets/pay-icon-curr2.png'):require('../../assets/pay-icon.png')" alt="">
        </span>
      </div>
      <div class="pay-bottom-li border-box" @click="payWay=1" v-if="isshow==1">
        <span class="fl">
          <img src="../../assets/pay-yhk.png" alt="">
          <font>一网通支付</font> <br/>
          <font class="pay-bottom-yh" v-if="res.ycut > 0">最高立减{{res.ycut}}元</font>
        </span>
        <span class="pay-icon">
          <img :src="payWay==1?require('../../assets/pay-icon-curr2.png'):require('../../assets/pay-icon.png')" alt="">
        </span>
      </div>
    </div>
    <div class="pay-bottom"  v-if="!(memberList && memberList.length > 0) && payWay!=3">
      <div class="pay-bottom-li border-box" @click="payWay=0">
        <span class="fl">
          <img src="../../assets/pay-wechat.png" alt="">
          微信支付
        </span>
        <span class="fr">
          <img :src="payWay==0?require('../../assets/pay-icon-curr2.png'):require('../../assets/pay-icon.png')" alt="">
        </span>
      </div>
      <div class="pay-bottom-li border-box" @click="payWay=1" v-if="isshow==1">
        <span class="fl">
          <img src="../../assets/pay-yhk.png" alt="">
          <font>一网通支付</font>
          <font class="pay-bottom-yh" v-if="res.ycut > 0">支付立减，最高{{res.ycut}}元</font>
        </span>
        <span class="fr">
          <img :src="payWay==1?require('../../assets/pay-icon-curr2.png'):require('../../assets/pay-icon.png')" alt="">
        </span>
      </div>
    </div>
    <!--潍坊市博物馆样式-->
    <template v-if="shopid==1815">
      <div class="view-footer" v-if="payWay==0&&!memberWay" @click="payWxOrder">
        <div class="lf">
          <div class="price">
            <span>￥</span>
            <b v-if="model==1&&isBuyOne==1">{{isBuyOnePrice}}</b>
            <b v-else>{{res.ntotal}}</b>
          </div>
          <div class="txt">
            包含147个讲解点<br/>一次购买，长期有效
          </div>
        </div>
        <div class="rt">
          立即支付
        </div>
      </div>
      <div class="view-footer" v-if="payWay==1&&!memberWay" @click="payYOrder">
        <div class="lf">
          <div class="price">
            <span>￥</span>
            <b>{{res.ytotal}}</b>
          </div>
          <div class="txt">
            包含147个讲解点<br/>一次购买，长期有效
          </div>
        </div>
        <div class="rt">
          立即支付
        </div>
      </div>
      <div class="view-footer" v-if="payWay == 3" @click="activeATO">
        <div class="lf">
          <div class="price">
            <span>￥</span>
            <b>0.00</b>
          </div>
          <div class="txt">
            包含147个讲解点<br/>一次购买，长期有效
          </div>
        </div>
        <div class="rt">
          立即激活
        </div>
      </div>
      <div class="view-footer" v-if="payWay==0&&memberWay==1" @click="payWxOrderMeb">
        <div class="lf">
          <div class="price">
            <span>￥</span>
            <b>{{memberList[memberInd].sellprice}}</b>
          </div>
          <div class="txt">
            包含147个讲解点<br/>一次购买，长期有效
          </div>
        </div>
        <div class="rt">
          立即支付
        </div>
      </div>
      <div class="view-footer" v-if="payWay==0&&memberWay==1" @click="payYOrderMeb">
        <div class="lf">
          <div class="price">
            <span>￥</span>
            <b>{{memberList[memberInd].ytotal}}</b>
          </div>
          <div class="txt">
            包含147个讲解点<br/>一次购买，长期有效
          </div>
        </div>
        <div class="rt">
          立即支付
        </div>
      </div>
    </template>
    <template v-else>
      <div class="pay-btn" v-if="payWay==0&&!memberWay" @click="payWxOrder">
        <div class="fl left">
          <div class="fl txt">合计：</div>
          <div class="fl price">
            <p class="p1" v-if="model==1&&isBuyOne==1"><span>￥</span>{{isBuyOnePrice}}</p>
            <p class="p1" v-else><span>￥</span>{{res.ntotal}}</p>
          </div>
        </div>
        <div class="right-btn">立即支付</div>
      </div>
      <div class="pay-btn" v-if="payWay==1&&!memberWay" @click="payYOrder">
        <div class="fl left"><div class="fl txt">合计：</div><div class="fl price"><p class="p1"><span>￥</span>{{res.ytotal}}</p></div></div>
        <div class="right-btn">立即支付</div>
      </div>
      <div class="pay-btn" v-if="payWay == 3" @click="activeATO">
        <div class="fl left"><div class="fl txt">合计：</div><div class="fl price"><p class="p1"><span>￥</span>0.00</p></div></div>
        <div class="right-btn">立即激活</div>
      </div>
      <div class="pay-btn" v-if="payWay==0&&memberWay==1" @click="payWxOrderMeb">
        <div class="fl left"><div class="fl txt">合计：</div><div class="fl price"><p class="p1"><span>￥</span>{{memberList[memberInd].sellprice}}</p></div></div>
        <div class="right-btn">立即支付</div>
      </div>
      <div class="pay-btn" v-if="payWay==1&&memberWay==1" @click="payYOrderMeb">
        <div class="fl left"><div class="fl txt">合计：</div><div class="fl price"><p class="p1"><span>￥</span>{{memberList[memberInd].ytotal}}</p></div></div>
        <div class="right-btn">立即支付</div>
      </div>
    </template>
    <!--<router-link class="pay-tip" to="/agreement">点击立即购买，即表示您已经同意<span>《金牌解说语音协议》</span></router-link>-->

    <div class="alert-box alert-boxpay" v-if="payAlert==1">
      <span class="mask"></span>
      <div class="alert-con border-box">
        <p class="tip">支付确认</p>
        <p class="tip tip1">请在微信内完成支付，如果您已支付成功，请点击“已完成支付”按钮</p>
        <div class="btn-box clearfix">
          <div class="fl btn line" @click="payAlert=0">取消</div>
          <div class="fr btn linear" @click="checkDYorderState">已完成支付</div>
        </div>
        <div class="cancel-rule cor6 box">
          <div class="l tr border-box">注意：</div>
          <div class="flex">如果您还未安装微信6.0.2及以上版本客户端，请点击“取消”并先更新微信版本</div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

  import { mapState, mapMutations } from 'vuex'
  import {getOrderProd, creatWxOrder, creatYOrder, pushOrder,creatWxOrderMeb, creatYOrderMeb,mulCreateOrder,getWxMini} from '@/utils/wechat'
  import {getOTAcode,activeOTAcode,checkShopIsOTA,needMember,bundlePrice,checkDYorder} from "@/service/getData";
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import AlertOTA from '../../components/AlertOTA'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        orderCode: this.$route.query.orderCode || '',
        userInfo: {}, //用户信息
        shopid: '', //景区id
        pid: '', //专辑id
        isbuy: 0, //未购买
        bagtype: '', //视频产品
        from: '', //来自于哪个页面
        isshow: '', //是否显示一网通

        res: {}, //返回结果
        bag: {}, //产品信息
        coupon: {}, //优惠卡包
        payWay: 0, //0:默认微信支付，1:一网通支付，2:支付宝支付，3:激活码激活，4:购买会员
        valueData: '',

        siteBrotherList: [], //所包含的语音包
        siteBrotherShow: true, //是否展开语音包

        appKey: '',
        OTAcode: '', //激活码
        OTAShow: 0, //是否显示激活码操作

        memberWay: 0, //是否开通会员
        memberList: [], //可购买的会员列表
        memberInd: 0, //选择购买哪个会员

        isBuyOne: 2, //2：默认购买当前语音  1：捆绑专辑购买
        isBuyOnePrice: 0, //多张购买的价格
        idsArr: [], //购买的单张专辑id数组
        model: 0, //1：捆绑包专辑购买

        appType: '', //支付类型
        payAlert: 0, //是否弹出支付提示弹窗
        isWxMini: false, //返回是否是小程序环境
      }
    },
    computed: {

    },
    created() {
      this.global.set_glabalClear()

      this.shopid = this.$route.query.shopid;
      this.pid = this.$route.query.pid;
      this.isbuy = this.$route.query.isbuy || '';
      this.bagtype = this.$route.query.bagtype || '';
      this.from = this.$route.query.from || '';
      this.userInfo = getStore("userInfo");

      this.appKey = this.$route.query.appKey || "";
      if (this.appKey) {
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey": this.appKey});
      } else {
        setStore("appKey", {"appKey": ""});
      }

      let couponid =  getStore("couponid"),cid;
      if(couponid){
        cid = couponid.couponid
      }
      this.cid = this.$route.query.cid || cid || "";

      if(this.isbuy == 1){
        setStore("couponid", {"couponid": ""});
        if(this.from == 'index'){
          this.$router.replace({
            path: `/?${'appKey='+this.appKey}`
          });
        }else if(this.bagtype == 1){
          this.$router.replace({
            path: `/video-play1?${'id='+this.pid+'&shopid='+this.shopid+'&form=pay&bagtype=1'+'&appKey='+this.appKey+'&paySuccess=1'}`
          });
        }else if(this.bagtype == 2){
          this.$router.replace({
            path: `/video-vr?${'id='+this.pid+'&shopid='+this.shopid+'&form=pay&bagtype=2'+'&appKey='+this.appKey+'&paySuccess=1'}`
          });
        }else if(this.bagtype == 4){
          this.$router.replace({
            path: `/video-list?${'id='+this.pid+'&shopid='+this.shopid+'&form=pay&bagtype=4'+'&appKey='+this.appKey+'&paySuccess=1'}`
          });
        }else if(this.bagtype == 5){
          this.$router.replace({
            path: `/view-detail-group?${'id='+this.pid+'&shopid='+this.shopid+'&form=pay&bagtype=5'+'&appKey='+this.appKey+'&paySuccess=1'}`
          });
        }else if(this.bagtype == 'lz'){
          this.$router.replace({
            path: `/video-play-lz?${'id='+this.pid+'&shopid='+this.shopid+'&form=pay&bagtype=lz'+'&appKey='+this.appKey+'&paySuccess=1'}`
          });
        }else if(this.bagtype == 'sm'){
          this.$router.replace({
            path: `/video-play-sm?${'id='+this.pid+'&shopid='+this.shopid+'&form=pay&bagtype=sm'+'&appKey='+this.appKey+'&paySuccess=1'}`
          });
        }else {
          this.$router.replace({
            path: `/video-play?${'id='+this.pid+'&shopid='+this.shopid+'&form=pay'+'&appKey='+this.appKey+'&paySuccess=1'}`
          });
        }

      }else {
        this.getProdInfo();
        this.showOTA();
      }
    },
    methods: {
      //初始化：获取景区数据
      getProdInfo(){
        var self = this;
        getOrderProd(self.pid,self.cid,function(res){
          if(res.errcode == "00000"){
            if(res.data.isbuy == 1){
              setStore("couponid", {"couponid": ""});
              if(self.shopid== null||self.shopid==undefined||self.shopid==""){
                self.shopid = res.data.shopid;
              }
              if(self.from == 'index'){
                this.$router.replace({
                  path: `/?${'appKey='+this.appKey}`
                });
              }else if(res.data.bag.bagtype == 1){  //单个视频专辑
                self.$router.replace({
                  path: `/video-play1?${'id='+self.pid+'&shopid='+self.shopid+'&form=pay&bagtype=1'+'&appKey='+self.appKey+'&paySuccess=1'}`
                });
              }else if(res.data.bag.bagtype == 2){  //VR专辑
                self.$router.replace({
                  path: `/video-vr?${'id='+self.pid+'&shopid='+self.shopid+'&form=pay&bagtype=2'+'&appKey='+self.appKey+'&paySuccess=1'}`
                });
              }else if(res.data.bag.bagtype == 4){  //短视频专辑
                self.$router.replace({
                  path: `/video-list?${'id='+self.pid+'&shopid='+self.shopid+'&form=pay&bagtype=4'+'&appKey='+self.appKey+'&paySuccess=1'}`
                });
              }else if(res.data.bag.bagtype == 5){  //类似于建川博物馆这样的组合场馆
                self.$router.replace({
                  path: `/view-detail-group?${'id='+self.pid+'&shopid='+self.shopid+'&form=pay&bagtype=5'+'&appKey='+self.appKey+'&paySuccess=1'}`
                });
              }else if(res.data.bag.bagtype == 0){  //正常专辑
                if(res.data.bag.shopType == "pavilion"){ //临展
                  self.$router.replace({
                    path: `/video-play-lz?${'id='+self.pid+'&shopid='+self.shopid+'&form=pay&bagtype=lz'+'&appKey='+self.appKey+'&paySuccess=1'}`
                  });
                }if(res.data.bag.shopType == "buddhism"){ //佛教寺庙
                  self.$router.replace({
                    path: `/video-play-sm?${'id='+self.pid+'&shopid='+self.shopid+'&form=pay&bagtype=sm'+'&appKey='+self.appKey+'&paySuccess=1'}`
                  });
                }else {
                  self.$router.replace({
                    path: `/video-play?${'id='+self.pid+'&shopid='+self.shopid+'&form=pay'+'&appKey='+self.appKey+'&paySuccess=1'}`
                  });
                }
              }
            }else {
              self.res = res.data;
              self.appType = res.data.appType || '';
              self.bag = res.data.bag;
              self.shopid = res.data.shopid;
              self.bagtype = res.data.bag.bagtype;
              if(res.data.bag.bagtype == 0 && res.data.bag.shopType == 'pavilion'){
                self.bagtype = 'lz';
              }else if(res.data.bag.bagtype == 0 && res.data.bag.shopType == 'buddhism'){
                self.bagtype = 'sm';
              }
              self.isshow = res.data.isshow;
              self.coupon = res.data.coupon;
              if(res.data.ntotal > res.data.ytotal){
                self.payWay = 1;
              }

              self.siteBrotherList = res.data.voice;

              getWxMini(function(res){
                self.isWxMini =  res;
                if(!res){
                  self.showMember();
                }
              });
//              self.checkShopIsOTA();

              self.model = res.data.model;
              if(self.model == 1&&res.data.voice.length>=2){ //捆绑包合集购买
                self.idsArr = self.getIdsArr();
                self.getBundlePrice();
                self.isBuyOne = 1;
              }
            }
          }
        });
      },

      //是否显示ota
      async checkShopIsOTA(){
        var self = this;
        let res = await checkShopIsOTA({
          shopid: self.shopid
        });
        if (res.errcode === "00000"){
          if(res.data.showActive == 1){
            this.OTAShow = 1;
          }else {
            this.payWay = 0;
            this.OTAShow = 0;
          }
        }
      },

      //显示OTA
      async showOTA(){
        let res = await getOTAcode();
        if (res.errcode === "00000"){
          this.OTAcode = res.data;
          this.OTAShow = 1;
          this.payWay = 3
        }
      },

      //是否显示会员购买
      async showMember(){
        let res = await needMember({
          id: this.shopid
        });
        if (res.errcode === "00000"){
          if(res.data.root && res.data.root.length > 0){
            this.memberList = res.data.root.reverse();
            this.memberWay = 1;
            this.memberInd = 0;

            if(res.data.snum&&res.data.snum==102){
              this.memberWay = 0;
              this.payWay = 0;
            }
          }
        }
      },

      //重新计算价格
      async getBundlePrice(){
        if(this.idsArr.length>=2){
          let res = await bundlePrice({
            openid: this.userInfo.openid,
            ids: this.idsArr.join(','),
            bundleid: this.res.bundleid
          });
          if(res.errcode === "00000"){
            this.isBuyOnePrice = res.data.price
          }
        }else {
          this.isBuyOnePrice = this.res.ytotal;
        }

      },

      memberClick(){
        if(this.memberWay == 1){
          this.memberWay = 0;
          this.memberInd = -1;
        }else {
          this.memberWay = 1;
          this.memberInd = 0;
        }
      },

      //去卡券页选择卡券
      goCoupon(){
        this.$router.push({
          path: `/coupon-list?${'pid='+this.pid+'&shopid='+this.shopid}`
        });
      },

      //立即购买(微信支付)
      payWxOrder(){
        MtaH5.clickStat('xiangqingyeshit',{'viewdetailpay':'true'});//景区景点点击试听》弹窗购买》1支付
        MtaH5.clickStat('zhuanjixiangqin',{'pay':'true'});//专辑详情页点击推荐景区》购买》1支付
        MtaH5.clickStat('viewspotbuy',{'2viewspotpay':'true'});//景区景点直接点击购买》1支付
        MtaH5.clickStat('jingqujingdiana',{'3pay':'true'});//景区景点点击导游头像》个人主页购买》1支付
        MtaH5.clickStat('jingqujingdiana-1',{'3pay':'true'});//景区景点试听》直接购买》1支付
        MtaH5.clickStat('jingqujingdiana-2',{'3pay':'true'});//景区景点进入专辑详情》点击购买》1支付
        MtaH5.clickStat('jingqujingdiana-3',{'4pay':'true'});//景区景点进入专辑详情》试听》购买》1支付

        var self = this;
        var id = self.pid,price = self.bag.price;

        if(this.model==1&&((this.payWay==0 || this.payWay==1) && !this.memberWay && this.isBuyOne==1) && this.idsArr.length>=2){ //多张专辑购买
          var ids = this.idsArr.join(',');
          var bundleid = this.res.bundleid;
          mulCreateOrder(self,ids,bundleid,function(data){
            setStore("couponid", {"couponid": ""});
            if(data){
              self.payWxSucc();
            }
          });
        }else {
          if(this.bag.id){
            if(this.model==1&&((this.payWay==0 || this.payWay==1) && !this.memberWay && this.isBuyOne==1) && this.idsArr.length==1){
              var ind = this.getIndex(this.siteBrotherList,this.idsArr[0]);
              id = this.idsArr[0];
              price = this.siteBrotherList[ind].price
            }else {
              id = this.bag.id
            }
          }
          creatWxOrder(self,id,price,self.cid,function(data){
            setStore("couponid", {"couponid": ""});
            if(data){
              self.payWxSucc();
            }
          });
        }

        self.payAlertTip();

      },

      //立即购买(一网通支付)
      payYOrder(){
        MtaH5.clickStat('xiangqingyeshit',{'viewdetailpay':'true'});//景区景点点击试听》弹窗购买》1支付
        MtaH5.clickStat('zhuanjixiangqin',{'pay':'true'});//专辑详情页点击推荐景区》购买》1支付
        MtaH5.clickStat('viewspotbuy',{'2viewspotpay':'true'});//景区景点直接点击购买》1支付
        MtaH5.clickStat('jingqujingdiana',{'3pay':'true'});//景区景点点击导游头像》个人主页购买》1支付
        MtaH5.clickStat('jingqujingdiana-1',{'3pay':'true'});//景区景点试听》直接购买》1支付
        MtaH5.clickStat('jingqujingdiana-2',{'3pay':'true'});//景区景点进入专辑详情》点击购买》1支付
        MtaH5.clickStat('jingqujingdiana-3',{'4pay':'true'});//景区景点进入专辑详情》试听》购买》1支付
        var self = this;
        var id = self.pid;
        if(self.bag.id){
          id = self.bag.id
        }
        creatYOrder(self,id,self.bag.price,self.cid,function(data){
          setStore("couponid", {"couponid": ""});
        });

        self.payAlertTip();
      },

      //立即激活
      async activeATO(){
        MtaH5.clickStat('xiangqingyeshit',{'viewdetailpay':'true'});//景区景点点击试听》弹窗购买》1支付
        MtaH5.clickStat('zhuanjixiangqin',{'pay':'true'});//专辑详情页点击推荐景区》购买》1支付
        MtaH5.clickStat('viewspotbuy',{'2viewspotpay':'true'});//景区景点直接点击购买》1支付
        MtaH5.clickStat('jingqujingdiana',{'3pay':'true'});//景区景点点击导游头像》个人主页购买》1支付
        MtaH5.clickStat('jingqujingdiana-1',{'3pay':'true'});//景区景点试听》直接购买》1支付
        MtaH5.clickStat('jingqujingdiana-2',{'3pay':'true'});//景区景点进入专辑详情》点击购买》1支付
        MtaH5.clickStat('jingqujingdiana-3',{'4pay':'true'});//景区景点进入专辑详情》试听》购买》1支付
        MtaH5.clickStat('jingqujingdiana-4',{'4pay':'true'});//景区景点进入专辑详情》试听》弹窗购买》1支付

        if(this.OTAcode=='' || this.OTAcode==null || this.OTAcode==undefined){
          this.$toast('请输入获得的激活码');
          return
        }

        var self = this;
        var id = self.pid;
        if(self.bag.id){
          id = self.bag.id
        }
        let res = await activeOTAcode({
          openid: this.userInfo.openid,
          pid: id,
          code: this.OTAcode
        });
        if (res.errcode == '00000') {
          this.$toast('激活成功');

          setTimeout(function(){
            self.payWxSucc();
          },500)
        }else {
          this.$toast(res.errmsg,{ duration: 2000 })
        }
      },

      //购买会员(微信支付)
      payWxOrderMeb(){
        MtaH5.clickStat('xiangqingyeshit',{'viewdetailpay':'true'});//景区景点点击试听》弹窗购买》1支付
        MtaH5.clickStat('zhuanjixiangqin',{'pay':'true'});//专辑详情页点击推荐景区》购买》1支付
        MtaH5.clickStat('viewspotbuy',{'2viewspotpay':'true'});//景区景点直接点击购买》1支付
        MtaH5.clickStat('jingqujingdiana',{'3pay':'true'});//景区景点点击导游头像》个人主页购买》1支付
        MtaH5.clickStat('jingqujingdiana-1',{'3pay':'true'});//景区景点试听》直接购买》1支付
        MtaH5.clickStat('jingqujingdiana-2',{'3pay':'true'});//景区景点进入专辑详情》点击购买》1支付
        MtaH5.clickStat('jingqujingdiana-3',{'4pay':'true'});//景区景点进入专辑详情》试听》购买》1支付
        let self = this;
        creatWxOrderMeb(self,self.memberList[self.memberInd].id,self.memberList[self.memberInd].sellprice,self.cid,function(data){
          setStore("couponid", {"couponid": ""});
          if(data){
            self.payWxSucc();
          }
        });

        self.payAlertTip();
      },

      payWxSucc(){
        let self = this;
        if(this.model==1&&((this.payWay==0 || this.payWay==1) && !this.memberWay && this.isBuyOne==1) && this.idsArr.length>0){
          var ind = this.getIndex(this.siteBrotherList,this.idsArr[0]);
          this.pid = this.siteBrotherList[ind].bid;
          this.shopid = this.siteBrotherList[ind].id;
          this.bagtype =  this.siteBrotherList[ind].bagtype;
        }

        if(self.from == 'index'){
          pushOrder('dist/index.html#/appKey='+ self.appKey);
        }else if(self.bagtype == 1){
          pushOrder('dist/index.html#/video-play1?id='+self.pid+'&shopid='+self.shopid+'&bagtype=1'+'&paySuccess=1'+ '&appKey='+ self.appKey);
        }else if(self.bagtype == 2){
          pushOrder('dist/index.html#/video-vr?id='+self.pid+'&shopid='+self.shopid+'&bagtype=2'+'&paySuccess=1'+ '&appKey='+ self.appKey);
        }else if(self.bagtype == 4){
          pushOrder('dist/index.html#/video-list?id='+self.pid+'&shopid='+self.shopid+'&bagtype=4'+'&paySuccess=1'+ '&appKey='+ self.appKey);
        }else if(self.bagtype == 5){
          pushOrder('dist/index.html#/view-detail-group?id='+self.pid+'&shopid='+self.shopid+'&bagtype=5'+'&paySuccess=1'+ '&appKey='+ self.appKey);
        }else if(self.bagtype == 'lz'){
          pushOrder('dist/index.html#/video-play-lz?id='+self.pid+'&shopid='+self.shopid+'&bagtype=lz'+'&paySuccess=1'+ '&appKey='+ self.appKey);
        }else if(self.bagtype == 'sm'){
          pushOrder('dist/index.html#/video-play-sm?id='+self.pid+'&shopid='+self.shopid+'&bagtype=sm'+'&paySuccess=1'+ '&appKey='+ self.appKey);
        }else {
          pushOrder('dist/index.html#/video-play?id='+self.pid+'&shopid='+self.shopid+'&paySuccess=1'+ '&appKey='+ self.appKey);
        }

      },

      //购买会员(一网通支付)
      payYOrderMeb(){
        MtaH5.clickStat('xiangqingyeshit',{'viewdetailpay':'true'});//景区景点点击试听》弹窗购买》1支付
        MtaH5.clickStat('zhuanjixiangqin',{'pay':'true'});//专辑详情页点击推荐景区》购买》1支付
        MtaH5.clickStat('viewspotbuy',{'2viewspotpay':'true'});//景区景点直接点击购买》1支付
        MtaH5.clickStat('jingqujingdiana',{'3pay':'true'});//景区景点点击导游头像》个人主页购买》1支付
        MtaH5.clickStat('jingqujingdiana-1',{'3pay':'true'});//景区景点试听》直接购买》1支付
        MtaH5.clickStat('jingqujingdiana-2',{'3pay':'true'});//景区景点进入专辑详情》点击购买》1支付
        MtaH5.clickStat('jingqujingdiana-3',{'4pay':'true'});//景区景点进入专辑详情》试听》购买》1支付
        let self = this;
        creatYOrderMeb(self,self.pid,self.memberList[self.memberInd].id,self.memberList[self.memberInd].sellprice,self.cid,function(data){
          setStore("couponid", {"couponid": ""});
        });
      },

      //跳转到专辑详情页面 / 勾选需要购买的专辑
      goViewDetail(id,bid,ind,bagtype){
        if(this.model==1&&((this.payWay==0 || this.payWay==1) && !this.memberWay && this.isBuyOne==1) && ind!==''){

          var idInd = this.idsArr.indexOf(bid);
          if (idInd > -1) {
            if(bid!=this.pid){
              this.idsArr.splice(idInd, 1);
            }
          }else {
            this.idsArr.push(bid);
          }

          this.getBundlePrice();
        }else {
          if(this.model===1 || (this.model!=1&&this.bag.ptype==1)){
            if(bagtype==2){
              this.$router.push({
                path: `/video-vr?${'shopid=' + id +'&id='+bid+'&appKey=' + this.appKey}`
              });
            }else {
              this.$router.push({
                path: `/video-play?${'shopid=' + id +'&id='+bid+'&appKey=' + this.appKey}`
              });
            }
          }else {
            this.$router.push({
              path: `/view-detail?${'shopid=' + id + '&appKey=' + this.appKey}`
            });
          }
        }
      },

      //拿到数组中指定id的下标
      getIndex(arr,id){
        let result;
        if(arr.find(function(x) {return x.bid == id;}) != undefined) {
          arr.find(function(x,i) {
            if(x.bid == id){
              result =  i;
            }
          });
          return result;
        }else {
          return 0;
        }
      },

      //获取专辑合集的所有专辑id
      getIdsArr: function (){
        var idsArr = [];
        for(var i=0; i<this.siteBrotherList.length; i++){
          if(this.pid == this.siteBrotherList[i].bid){
            idsArr.push(this.siteBrotherList[i].bid);
            break;
          }
        }
        for(var i=0; i<this.siteBrotherList.length; i++){
          if(this.pid != this.siteBrotherList[i].bid){
            idsArr.push(this.siteBrotherList[i].bid);
          }
        }
        return idsArr;
      },

      //点击购买多张专辑
      isBuyOneClick: function (){
        if(this.isshow==1){
          this.payWay=1;
        }else {
          this.payWay=0;
        }

        this.idsArr = this.getIdsArr();
        this.memberWay=0;
        this.isBuyOne=1;
        this.siteBrotherShow=true;
        this.getBundlePrice()
      },

      //5s后自动弹出支付确认弹窗
      payAlertTip(){
        var self = this;
        setTimeout( function(){
          let payInfo = getStore("payInfo");
          let pay_info = (payInfo && payInfo.pay_info) || "";
          if(pay_info==1){//pay_info :  1 (h支付) 其他值维持原样
            self.payAlert = 1;
          }
        },5000);
      },

      //检查订单状态
      async checkDYorderState(){
        let res2 = await checkDYorder({
          code: this.orderCode
        });
        if (res2.errcode === "00000"){
          if(res2.data == 12){ //支付成功
            this.$toast("支付成功");
            var self = this;
            setTimeout(function(){
              self.payWxSucc();
            },2000);
          }else if(res2.data == 13){  //支付关闭
            this.$toast("支付关闭");
          }else if(res2.data == 10){  //订单状态未知/未支付
            this.$toast("未查询到支付状态，请重新支付");
          }else{
            this.$toast("支付失败");
          }
        }
      },

    },
    components: {
      AlertOTA
    },
  }

</script>

<style scoped>
  .page{min-height:100vh;padding:.24rem .3rem 1.8rem;background: #f3f3f3;}
  .pay-top{padding: 0 .24rem .2rem;background: #fff;border-radius: .14rem;}
  .pay-top-li{width: 100%;height: .9rem;line-height:.9rem;border-bottom: 1px dashed #a5a5a5;}
  .pay-top-li span{font: .28rem/.9rem "Microsoft YaHei";}
  .pay-top-li .fl{color: #3f3f3f;}
  .pay-top-li .fr{color: #ff5455;}
  .pay-top-li .fr img{float: right;width:auto;height: .15rem;margin-top: .445rem;margin-left: .2rem;}
  .pay-top-li input{float: right;font: bold .28rem/.9rem "Microsoft YaHei"; color:#222;max-width:63%; text-align: right; }
  .pay-top-tip{padding-top: .14rem;color: #3f3f3f;}
  .pay-top-tip p{font-size: .24rem;}
  .pay-top-tip div{margin-top:.1rem;font-size: .22rem;line-height: .36rem;}

  .pay-bottom{margin-top:.24rem;padding: 0 .3rem;background: #fff;border-radius: .08rem;}
  /*.pay-btn{ display: block; padding: 0; width: 85%;height: .98rem;margin:.69rem auto 0;font: .32rem/.98rem "Microsoft YaHei";color: #fff;text-align: center;background: linear-gradient(to right, #fccd5b, #faaf39);border-radius: .6rem;box-shadow: 0 20px 40px #f5efc9;}*/
  /*.pay-btn span{margin-left: .11rem;}*/
  .pay-tip{display: block;width: 85%;margin: .26rem auto 0;line-height:.4rem;font-size: .2rem;color: #333;text-align: center;}
  .pay-tip span{color:#fecf02;}
  .pay-bottom-li{position:relative;width: 100%;height: 1rem; line-height: 1rem; padding-left: .74rem; -webkit-box-align: center; -ms-flex-align: center; align-items: center;}
  .pay-bottom-li .fl{font-size: .28rem;color: #2e2a27;}
  .pay-bottom-li .fl img{position:absolute;left:0;top:50%;width: .45rem;height:auto;transform: translateY(-50%);}
  .pay-bottom-li .fr img{float: right;width: .4rem;height: .4rem;margin-top: .3rem;}
  .pay-bottom-yh{ padding: .02rem .15rem; color:#fff; font-size: .2rem; background-color: #ff5455; border-radius: .3rem; }

  .pay-vip-tip{ display: block; font-size: .24rem; color: #666; line-height: .3rem; margin-top: -.2rem; }
  .vip-list{ padding: .14rem .25rem .3rem; -webkit-box-align: center; -ms-flex-align: center; align-items: center; }
  .vip-list > .flex{ width: 33.33%; }
  .vip-box{ margin: 0 .14rem; height: 1.2rem; border: .02rem solid #dbdce0; border-radius: .08rem; text-align: center; font-weight: bold; }
  .vip-box .top{ height: .4rem; line-height: .4rem; font-size: .24rem; color: #666; background-color: #e8e8e8; }
  .vip-box .pri{ height: .8rem; line-height: .8rem; font-size: .3rem; color: #ff5511; }
  .vip-box .pri i{ font-size: .24rem; font-style: normal; }
  .vip-box .pri b{ font-size: .22rem; color: #999; text-decoration: line-through; }
  .vip-box.curr{ border-color: #fac551; }
  .vip-box.curr .top{ color: #825d0e; background-color: #fac551; }

  .pay-box{padding: .3rem;margin-top:.3rem;background: #fff;border-radius: .08rem;}
  /*.pay-box:first-child{margin-top: 0;}*/
  .video-img{width: 1.58rem;height: 1.58rem;margin-right: .24rem;border-radius: .08rem;object-fit: cover;}
  .video-tit{ margin-top: .1rem; font-weight: bold;color: #333;font-size: .36rem;}
  .video-num{font-weight: bold;color: #666;font-size: .3rem;}
  .video-price{margin-top:.12rem;font-weight: bold;font-size: .36rem;color: #e41919; line-height: .4rem;}

  .vip-li{position: relative;border: 1px solid #fff;}
  .vip-li.curr{border: 1px solid #fcc753;background: #fffcf7;}
  .vip-li .price-rt{position: absolute;top:.3rem;right:.3rem;font-size: .36rem;font-weight: bold;color: #e41919;}
  .vip-li .price-rt b{ font-weight: normal; font-size: .28rem; color: #999; text-decoration: line-through; }
  .vip-li .vip-top{font-size: .34rem;color: #333;font-weight: bold;}
  .vip-li .vip-top img{display: inline-block;width: auto;height: .4rem;vertical-align: sub;}
  .vip-li .vip-top span{font-size: .28rem;color: #666;font-weight: bold;}
  .vip-li .vip-bot{margin-top:.26rem;font-size: .28rem;color: #666;font-weight: bold;}
  .vip-li .vip-bot.cont .fr{ color: #e41919; }
  .vip-li .vip-bot.cont .fr img{ width: .13rem; }
  .vip-li .vip-bot.code{width: 100%;height: .72rem;margin-top: .15rem;border-radius: .08rem;overflow: hidden;}
  .vip-li .vip-bot.code input{display: inline-block;width: 100%;height:100%;padding: 0 .16rem;border-radius: .08rem;background: #f6f6f6;font-size: .28rem;color: #666;}
  .pay-bottom1{height: 1.26rem;margin-top:.24rem;padding: 0 .3rem;background: #fff;border-radius: .08rem;}
  .pay-bottom1 .pay-bottom-li{position:relative;height: 1.26rem;line-height: 1.26rem;padding-left: .74rem;}
  .pay-bottom1 .pay-bottom-li .fl{font-size: .28rem;color: #2e2a27; }
  .pay-bottom1 .pay-bottom-li .fl img{position:absolute;left:0;top:50%;width: .45rem;height:auto;transform: translateY(-50%);}
  .pay-bottom1 .pay-bottom-li .pay-icon img{float: right;width: .4rem;height: .4rem;margin-top: .43rem;margin-left: .16rem;}
  .pay-bottom1 .pay-bottom-li.noOtherPay{width: 100%;}
  .pay-bottom1 .pay-bottom-li.noOtherPay .pay-icon img{float: right;}
  .pay-bottom1 .pay-bottom-li .fl .pay-bottom-yh{ position: absolute; height: .24rem;left: .74rem; top: .8rem; line-height: .24rem; border-radius: 0 .09rem .09rem .09rem; }
  .pay-btn{position: fixed;left: 0;right: 0;bottom:0;height: 1.36rem;background: #fff;}
  .pay-btn .left{width: calc(57.34vw - 1.02rem);margin-top: .44rem;margin-left: .4rem;}
  .pay-btn .left .txt{font-size: .28rem;color: #333;font-weight: bold;}
  .pay-btn .left .price{padding-left:.2rem;color: #e41919;font-weight: bold;}
  .pay-btn .price .p1{font-size: .36rem;}
  .pay-btn .price .p1 span{font-size: .28rem;}
  .pay-btn .price .p2{font-size: .24rem;}
  .pay-btn .right-btn{position:absolute;z-index:1;top:.24rem;right:.3rem;width: 42.66%;height: .88rem;line-height: .88rem;margin-left:.32rem;background: #fcc753;border-radius: .5rem;font-size: .34rem;font-weight: bold;color: #333;text-align: center;  }

  /*建川博物馆类型*/
  .video-price .fr{ position: relative; font-weight: normal;font-size: .24rem; color: #666; }
  .video-price .fr:after{ position: absolute; left: 50%; top: .4rem; z-index: 1; margin-left: -.12rem; width:.24rem; height:.13rem; background: url(../../assets/icon-down.png) no-repeat center; background-size: 100% 100%; content: ''; }
  .video-price .fr.curr:after{ transform: rotate(180deg) ; }

  .group-ul{ background-color: #fff; padding: 0 .24rem; }
  .group-li{ position: relative; padding: .15rem .4rem .15rem 0; background-color: #fff; border-top: .01rem solid #e0e0e0; }
  .group-li:after{ position: absolute; right: .15rem; top: 50%; margin-top: -.09rem; width:.11rem; height:.18rem;  background: url(../../assets/back.png) no-repeat center; background-size: 100% 100%; content: ''; }
  .group-li img{ width: .6rem; height: .6rem; object-fit: cover; }
  .group-li p{  margin-left: .3rem;height: .6rem; line-height: .6rem; font-size: .26rem; color: #333;  }

  .group-ul1 .group-li:after{ margin-top: -.15rem; width:.3rem; height:.3rem;  background: url(../../assets/pay-icon.png) no-repeat center; background-size: 100% 100%; content: ''; }
  .group-ul1 .group-li.curr:after{background: url(../../assets/pay-icon-curr1.png) no-repeat center; background-size: 100% 100%; content: ''; }
  .group-ul1 .group-li p{height: auto;line-height: .34rem;}


  /*app链接h5支付*/
  .alert-boxpay{position:fixed;top:0;right:0;bottom:0;left:0;z-index:999;}
  .alert-boxpay .mask{position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.6);}
  .alert-boxpay .alert-con{position: absolute;left: .6rem;top:50%;right: .6rem;padding:.4rem .4rem .5rem;background:#fff;-webkit-transform: translateY(-50%);transform: translateY(-50%);border-radius: .14rem;overflow: hidden;}
  .alert-boxpay .tip{margin-top:.16rem;font: bold .36rem/.6rem "Microsoft YaHei";color: #333;text-align: center;}
  .alert-boxpay .tip1{font: .32rem/.5rem "Microsoft YaHei";}
  .alert-boxpay .btn-box .btn{ margin: .4rem 0 0; width: 46.54%;height: .78rem;line-height: .78rem;}
  .alert-boxpay .cancel-rule{margin-top:.3rem;font: .22rem/.4rem "Microsoft YaHei";}
  .alert-boxpay .cancel-rule .l{padding-right: .1rem;}
  .alert-boxpay .btn{width: 2rem;height: .7rem;margin-left:.16rem;font: .32rem/.7rem "Microsoft YaHei";color: #333;border:1px solid #feca50;border-radius: .5rem;text-align: center;}
  .alert-boxpay .btn.linear{background: linear-gradient(right,#ffac3e,#feca50);}
  .alert-boxpay .btn.line{background: none;border:1px solid #e3e3e3;}

  /*潍坊市博物馆支付样式*/
  .view-footer{position: fixed;display: flex;align-items: center;justify-content: center;left: 0;bottom: 0;width: 100%;height: 1.8rem;padding:0.3rem; background: #fff;box-shadow: 0 0 0.05rem #ddd;z-index: 999;box-sizing: border-box;}
  .view-footer .lf{display: flex;align-items: center;height: 100%;border-top-left-radius: 0.6rem;border-bottom-left-radius: 0.6rem; padding:0 0.3rem;color:#fff;background: #000;}
  .view-footer .rt{position:relative; flex:1;height: 100%;border-top-right-radius: 0.6rem;border-bottom-right-radius: 0.6rem;text-align: center;line-height: 1.2rem;font-weight: 900;font-size: 0.36rem; background:#fec200;}
  .view-footer .lf .price{margin-right:0.2rem;}
  .view-footer .lf .price span{font-size:0.28rem;}
  .view-footer .lf .price b{margin-left: -0.06rem;font-size:0.6rem;font-weight: bold;}
  .view-footer .lf .txt{font-size:0.24rem;}
  .view-footer .rt:before{position: absolute;content: '';left: 0;top: 0;width: 0;height: 0;border-top: 1.2rem solid #000000;border-right: 0.2rem solid transparent;border-left: 0px solid transparent;}
</style>



// WEBPACK FOOTER //
// src/page/pay/pay.vue